import { ArrowRight, LockKeyhole } from "lucide-react";

export const AdminLoginForm = ({ email, error, handleGoogle, handleLogin, password, setEmail, setPassword, submitting }) => <div className="admin-login-card">
  <LockKeyhole />
  <span className="admin-kicker">Secure administrator access</span>
  <h2 data-testid="admin-sign-in-heading">Sign in</h2>
  <p>Use your NCP administrator account.</p>
  <form onSubmit={handleLogin} data-testid="admin-login-form">
    <label htmlFor="admin-email">Email address</label>
    <input id="admin-email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" required data-testid="admin-email-input" />
    <label htmlFor="admin-password">Password</label>
    <input id="admin-password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" required data-testid="admin-password-input" />
    {error && <p className="admin-error" data-testid="admin-login-error">{error}</p>}
    <button type="submit" disabled={submitting} data-testid="admin-login-submit-button">{submitting ? "Signing in…" : "Sign in"}<ArrowRight /></button>
  </form>
  <div className="admin-divider"><span>or</span></div>
  <button type="button" className="google-login" onClick={handleGoogle} data-testid="admin-google-login-button"><strong>G</strong> Continue with Google</button>
</div>;